import App from './App.svelte';

const app = new App({
    target: document.querySelector('#App'),
});

export default app;
